import { module as Module } from 'modujs';
import { $screenDebounce } from '../stores/screen';

export default class SectorAnchors extends Module {
    static INVIEW_CLASS = 'has-sector-anchors-inview';

    constructor(m) {
        super(m);

        // Binding
        this.onResize = this.onResize.bind(this);

        // UI
        this.$links = this.$('link');
        this.$list = this.$('list')[0];
        this.$threshold = this.$('threshold')[0];
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    init() {
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.unbindScreenListener = $screenDebounce.subscribe(this.onResize);
    }

    unbindEvents() {
        this.unbindScreenListener?.();
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onUpdateIndicator(e) {
        const { target, way } = e;

        if (way === 'enter') {
            this.$links.forEach(($link) => {
                const href = $link.getAttribute('href');
                if (href === `#${target.id}`) {
                    $link.classList.add('is-active');
                    this.scrollToBar($link);
                } else {
                    $link.classList.remove('is-active');
                }
            });
        } else if (way === 'leave') {
            this.$links.forEach(($link) => {
                const href = $link.getAttribute('href');
                if (href === `#${target.id}`) {
                    $link.classList.remove('is-active');
                }
            });
        }
    }

    onInview(e) {
        document.documentElement.classList.toggle(SectorAnchors.INVIEW_CLASS, e.way == 'enter');
    }

    onResize() {
        this.setThresholdHeight();
    }

    // =============================================================================
    // Methods
    // =============================================================================
    scrollToBar($target) {
        const offsetLeft = $target.offsetLeft;
        this.$list.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    setThresholdHeight() {
        this.el.style.setProperty('--threshold-height', `${this.$threshold.offsetHeight}px`);
    }
}
